<template>
  <v-list-tile 
    class="card-nota-item__wrap">
    <v-list-tile-content class="text-truncate text-no-wrap">
      <span>
        <v-icon 
          left 
          dark 
          small 
          color="secondary">{{ item.icon }}</v-icon>
        <span class="secondary--text font-weight-black">{{ item.descrizione_categoria | Upper }} </span>
        <span v-if="isSpesaAziendale">*</span>
        <v-tooltip right>
          <v-icon 
            v-if="isAbbonamento" 
            slot="activator" 
            right 
            dark 
            small 
            color="light-blue darken-4">fas fa-credit-card</v-icon>
          <span>Abbonamento</span>
        </v-tooltip>
      </span>
      <span 
        v-if="item.targa" 
        class="auto-desc">
        <span class="font-weight-medium">{{ item.titolo }} ({{ item.km }} km)</span>
        <span 
          style="width: 100%" 
          class="tratta-desc font-weight-light font-italic text-truncate">{{ item.via_p }} - {{ item.via_d }}</span>
      </span>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-list-tile-action-text 
        :style="[{'color': color}]" 
        class="text-no-wrap">
        {{ item.importo }} €
        <v-tooltip 
          bottom 
          color="secondary">
          <v-icon 
            slot="activator" 
            :style="[{'color': color}]" 
            class="ml-1" 
            size="14">fas fa-info</v-icon>
          <v-stepper 
            v-model="step" 
            vertical 
            dark 
            class="secondary elevation-0">
            <v-stepper-step 
              v-for="(st, i) in stepBody" 
              :key="i" 
              :color="st.color" 
              :complete="inviata + 1 >= step" 
              :step="i + 1">{{ st.title }}<small>{{ st.message }}</small></v-stepper-step>
          </v-stepper>
        </v-tooltip>
      </v-list-tile-action-text>
    </v-list-tile-action>
  </v-list-tile>
</template>
<script>
import CambiaNota from "./CambiaNota.vue";

export default {
  name: "AccCardNotaItem",
  components: {
    CambiaNota
  },
  filters: {
      Upper(val) {
          return val.toUpperCase()
      }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({
  }),
  computed: {
    step :{
        get () {
            switch (+this.item.stato) {
                case 0: return 1;
                case 1: return 3;
                case 2: return 3;
                case 3: return 1;
                case 4: return 2;
                case 5: return 2;
            }
        },
        set() {}
    },
    stepBody () {
        switch (+this.item.stato) {
            case 0: return [{title: (this.inviata === 0 ? 'Non lavorata' : 'Inviata a SAMM'), message: '', color: '#9E9E9E'}, {title: 'In lavorazione SAMM', message: '', color: '#9E9E9E'}, {title: 'Non lavorata', message: '', color: '#9E9E9E'}];
            case 1: return [{title: 'Inviata a SAMM', message: '', color: '#66BB6A'}, {title: 'Confermata SAMM', message: '', color: '#66BB6A'}, {title: 'Confermata GM', message: '', color: '#1B5E20'}];
            case 2: return [{title: 'Inviata a SAMM', message: '', color: '#66BB6A'}, {title: 'Confermata SAMM', message: '', color: '#66BB6A'}, {title: 'Annullata GM', message: this.item.motivo_no_conferma, color: '#B71C1C'}];
            case 3: return [{title: 'In attesa di modifica', message: this.item.motivo_no_conferma, color: '#FFC107'}, {title: 'In lavorazione SAMM', message: '', color: '#9E9E9E'}, {title: 'Non lavorata', message: '', color: '#9E9E9E'}];
            case 4: return [{title: 'Inviata a SAMM', message: '', color: '#66BB6A'}, {title: 'Confermata SAMM', message: '', color: '#66BB6A'}, {title: 'In lavorazione GM', message: '', color: '#9E9E9E'}];
            case 5: return [{title: 'Inviata a SAMM', message: '', color: '#66BB6A'}, {title: 'Annullata SAMM', message: this.item.motivo_no_conferma, color: '#EF5350'}, {title: 'Non lavorata GM', message: '', color: '#9E9E9E'}];
        }
    },
    isNotEditable() {
      return [1, 2, 4, 5].includes(+this.item.stato)
    },
    color() {
        switch (+this.item.stato) {
            case 0: return '#9E9E9E';
            case 1: return '#1B5E20';
            case 2: return '#B71C1C';
            case 3: return '#FFC107';
            case 4: return '#66BB6A';
            case 5: return '#EF5350';
        }
    },
    message() {
        switch (+this.item.stato) {
            case 0: return 'Non lavorato';
            case 1: return 'Confermato GM';
            case 2: return 'Anullato GM';
            case 3: return 'In attesa della modifica';
            case 4: return 'Confermato SAMM';
            case 5: return 'Anullato SAMM';
        }
    },
    isSpesaAziendale() {
        return Boolean(+this.item.is_anticipata_azienda)
    },
    isAbbonamento() {
        return Boolean(+this.item.is_abbonamento)
    },
    firmato() {
        return Boolean(this.item.data_firma)
    },
    inviata() {
        return +this.item.inviata
    }
  },
  methods: {
  }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// modules/Home/views/src/components/CardNotaItem.vue